import { defaultHttpClient } from 'shared/src/api/httpClient';

export type PostBookmarkOutfitResponse = {
  // '저장한 코디' 페이지로 이동하기 위한 deeplink. 응답이 없을 경우 null로 처리
  deeplink: string | null;
};

export const postBookmarkOutfit = (sno: number) => {
  return defaultHttpClient
    .request<PostBookmarkOutfitResponse>({
      method: 'POST',
      url: `/api/v2/outfits/${sno}/bookmark/`,
    })
    .then(result => result.data);
};
